<template>
    <div class="cdc-details-ba">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">

                            <div class="btn-back" @click="$router.push({ name: 'cdcByTeam' , params: { 'wptlid': $route.params.wptlid }});">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            cdc Details
                        </div>
                    </div>    

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <!-- <button class="btn btn-ecdc btn-shadow ml-3">Export Report</button> -->
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="reference-card">

                <h2 class="section-title">Showing Results For:</h2>
                
                <div class="table-responsive">
                    <table class="table table-striped result-table reference-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>BA Name</th>
                                <th>Division</th>
                                <th>Region</th>
                                <th>Area</th>
                                <th>Venue</th>
                                <th>Category</th>
                                <th class="text-right">Number of Cdc</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>{{topResult.start_date}}</td>
                                <td>{{topResult.ba_name}}</td>
                                <td>{{topResult.division}}</td>
                                <td>{{topResult.region_name}}</td>
                                <td>{{topResult.area_name}}</td>
                                <td>{{topResult.venue_name}}</td>
                                <td>{{topResult.venue_category}}</td>
                                <td class="text-right">{{topResult.number_of_cdc}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row">
                <div id="table-content-col" class="col-xl col-lg">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                        </div>

                        <div class="col-sm">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-hover table-striped result-table">
                            <thead>
                                <tr>
                                    <th>Date & Time</th>
                                    <th>Customer Name</th>
                                    <th>KTP</th>
                                    <th>Age</th>
                                    <th>Gender</th>
                                    <th>Contact No.</th>
                                    <th>WhatsApp</th>
                                    <th>Email</th>
                                    <th>Occupation</th>
                                    <th>Address</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="cdc in cdcBaData.result" v-bind:key="cdc.customer_id">
                                    <td>{{cdc.date}}</td>
                                    <td>{{cdc.customer_name}}</td>
                                    <td>{{cdc.ktp != 0 ? cdc.ktp : "-"}}</td>
                                    <td>{{cdc.age}}</td>
                                    <td>{{cdc.gender}}</td>
                                    <td>{{cdc.contact_number}}</td>
                                    <td>{{cdc.whatsapp_num}}</td>
                                    <td class="case-ignore">{{cdc.email != 0 ? cdc.email : "-"}}</td>
                                    <td>{{cdc.occupation}}</td>
                                    <td>{{cdc.address}}</td>
                                    <td class="text-center" @click="view(cdc.customer_id, cdc.engagement_id)">
                                        <button class="btn btn-link btn-icon icon-right">
                                            View 
                                            <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-items-center table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-3 mt-lg-0">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getCdcByBa } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate
    },
    data() {
        return {
            data: {
                work_progress_ba_id: this.$route.params.wpbaid,
                venue_id: this.$route.params.venue_id
            },
            cdcBaData: "",
            topResult: "",
            isLoading: true,
            proj_id: "2",
            canCreate: false,
            canEdit: false,
            totalPage: 0,
            pageLimit: 15,
            showingResults: ""
        }
    },
    async mounted() {

        await this.getCdcByBa(1);
        this.isLoading = false;
    },
    methods: {
        async getCdcByBa(pageNum) {

            try {

                const result = await getCdcByBa(this.data, pageNum, this.pageLimit);

                this.topResult = result.data.data.top_result;
                this.cdcBaData = result.data.data.cdc_detail_by_ba;
                this.totalPage = this.cdcBaData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.cdcBaData.total)
                    endPage = this.cdcBaData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.cdcBaData.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;  
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getCdcByBa(pageNum);

            this.isLoading = false;
        },
        view(cid, eid) {
            this.$router.push({ name: "cdcCustomerDetail" , params: { 'cid': cid, 'eid': eid, 'wpbaid': this.data.work_progress_ba_id, 'wptlid': this.$route.params.wptlid , 'venue_id': this.$route.params.venue_id }});
        }
    }
}
</script>